module.exports = __webpack_public_path__ + "static/media/tresd-icon.ef927ee7.svg";